module.exports = __webpack_public_path__ + "static/media/icono_asignaturas.1f823fce.svg";